import { GlobalResponseObject } from "../global-response-object";
import { VehicleIssueData } from "./vehicle-issue-req";

export class AllVehicleIssueResponseModel extends GlobalResponseObject {
  data?: VehicleIssueData[];

  constructor(
    status: boolean,
    intlCode: number,
    internalMessage: string,
    data?: VehicleIssueData[]
  ) {
    super(status, intlCode, internalMessage);
    this.data = data;
  }
}
